import React from 'react';
import { Box, useMediaQuery, useTheme } from '@material-ui/core';
import { useIntl } from 'react-intl';
import { ComplianceTable } from '../CarryLK/List/ComplianceTable';
import { StepButtonBar } from './StepButtonBar';
import EvaluationStepInfo from './EvaluationStepInfo';

interface Step6LawsTableProps {
  selectedRows: any[];
  setSelectedRows: (rows: any[]) => void;
  selectedRowsData: any[];
  setSelectedRowsData: (data: any[]) => void;
  selectedRequirementType: any;
  selectedCompanyUnit: any;
  onNext: () => void;
  onBack: () => void;
  onCancel: () => void;
  evalutionStepInfo: any;
  currentStepName: any;
  onUpdateEvalution?: (data: any) => void;
}

const Step6LawsTable = ({
  selectedRows, setSelectedRows, selectedRowsData, setSelectedRowsData,
  selectedRequirementType, selectedCompanyUnit, onNext, onBack, onCancel, evalutionStepInfo, currentStepName, onUpdateEvalution,
}: Step6LawsTableProps) => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const paperPadding = isMobile ? theme.spacing(2) : theme.spacing(3);

  return (
    <div style={{ width: '100%' }}>
      <div
        style={{
          display: 'flex',
          width: '100%',
          gap: '10px',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: 'stretch',
        }}
      >
        <div
          style={{
            // width: isMobile ? '100%' : 'calc(60% - 5px)',
             width: "100%",
            flexShrink: 0,
            padding: paperPadding,
            backgroundColor: '#f7f0f1',
            display: 'flex',
            flexDirection: 'column',
            boxSizing: 'border-box',
            justifyContent: 'flex-start',
            alignItems: 'stretch',
          }}
        >
          {selectedRequirementType && selectedCompanyUnit && (
            <Box style={{maxHeight: '350px', overflow: 'auto' }}>
              <ComplianceTable
                selectedRows={selectedRows}
                type={selectedRequirementType}
                setSelectedRows={setSelectedRows}
                companyUnit={{ label: selectedCompanyUnit?.name, value: selectedCompanyUnit?.id }}
                showMarkAll
                actionLabel={formatMessage({ id: 'law-portal.manage.law-list.table.add.law' })}
                selectedRowsData={selectedRowsData}
                setSelectedRowsData={setSelectedRowsData}
              />
            </Box>
          )}
        </div>

        {/* <EvaluationStepInfo evalutionStepInfo={evalutionStepInfo} currentStepName={currentStepName} onUpdate={onUpdateEvalution} /> */}
      </div>

      <Box>
        <StepButtonBar
          onCancel={onCancel}
          onBack={onBack}
          onNext={onNext}
          nextLabel="form.save.and.back"
          nextDisabled={selectedRows.length === 0}
          formatMessage={formatMessage}
        />
      </Box>
    </div>
  );
};

export default Step6LawsTable;